import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DocumentIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DocumentIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M17.9074 22H6.05423C5.21154 22 4.52588 21.3143 4.52588 20.4717V3.52835C4.52588 2.68566 5.21155 2 6.05423 2H13.9136C14.0474 2 14.1754 2.05316 14.2699 2.14766L19.2881 7.16538C19.3827 7.25989 19.4358 7.38787 19.4358 7.52176V20.4717C19.4358 21.3143 18.7501 22 17.9074 22ZM6.05423 3.00807C5.76726 3.00807 5.53395 3.24139 5.53395 3.52835V20.4717C5.53395 20.7586 5.76727 20.9919 6.05423 20.9919H17.9074C18.1944 20.9919 18.4277 20.7586 18.4277 20.4717V7.73046L13.7048 3.00807H6.05423Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.9702 8.07256H13.9519C13.6733 8.07256 13.4479 7.84712 13.4479 7.56852V2.50404C13.4479 2.22544 13.6733 2 13.9519 2C14.2305 2 14.456 2.22544 14.456 2.50404V7.06449H18.9702C19.2488 7.06449 19.4742 7.28992 19.4742 7.56852C19.4742 7.84712 19.2488 8.07256 18.9702 8.07256Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.0757 13.5594H8.88598C8.60738 13.5594 8.38195 13.3339 8.38195 13.0553C8.38195 12.7767 8.60738 12.5513 8.88598 12.5513H15.0757C15.3543 12.5513 15.5797 12.7767 15.5797 13.0553C15.5797 13.3339 15.3543 13.5594 15.0757 13.5594Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.0757 17.3578H8.88598C8.60738 17.3578 8.38195 17.1324 8.38195 16.8538C8.38195 16.5752 8.60738 16.3498 8.88598 16.3498H15.0757C15.3543 16.3498 15.5797 16.5752 15.5797 16.8538C15.5797 17.1324 15.3543 17.3578 15.0757 17.3578Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DocumentIcon;
